module.exports = __webpack_public_path__ + "static/header_menu-045b981313b7484363785c283044f432.jpg";